import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import '../App.scss';
import classNames from 'classnames';
import { GetTrades, GetTradesByProduct } from '../functions/Trades';
import { enableQuestionsInSet } from '../functions/QuestionEnabling';
import { IsWebReference } from '../functions/Configuration';
export default function IncompleteQuote(props: any) {
    props.setCurrentPage(0);
    props.setSidebarVisibility(false);
    const [trades, setTrades] = useState<any[]>([]);
    const [exactTrades, setExactTrades] = useState<any[]>([]);
    const [suggestedTrades, setSuggestedTrades] = useState<any[]>([]);
    const [selectedTrade, setSelectedTrade] = useState<string>("");
    const [selectedTradeObject, setSelectedTradeObject] = useState<any>("");
    const [validTrade, setValidTrade] = useState<boolean>(false);
    const [invalidTrade, setInvalidTrade] = useState<boolean>(false);
    const [invalidStatus, setInvalidStatus] = useState<boolean>(false);
    const [showResults, setShowResults] = useState<boolean>(false);
    const [selectedStatus, setSelectedStatus] = useState<string>("");
    const [initalPageLoad, setInitialPageLoad] = useState(true);

    let webReference = localStorage.getItem("webReference") || "";

    const navigate = useNavigate();

    var tradeClassNames = classNames(
        {
            'trade-selection': true,
            'valid-trade': validTrade,
            'invalid-trade': invalidTrade
        }
    );

    var statusClassNames = classNames(
        {
            'trade-selection': true,
            'valid-trade': selectedStatus !== "",
            'invalid-trade': invalidStatus
        }
    );

    useEffect(() => {
        setTrades(GetTradesByProduct(webReference).sort((a, b) =>
            a.description > b.description ? 1 : -1,
        ));

        setInitialPageLoad(false);
    }, [])

    const selectExactTrade = (index: number) => {
        setSelectedTrade(exactTrades[index].description);
        setSelectedTradeObject(exactTrades[index]);
        setShowResults(false);
        setValidTrade(true);
        setInvalidTrade(false);
    }

    const selectSuggestedTrade = (index: number) => {
        setSelectedTrade(suggestedTrades[index].description);
        setSelectedTradeObject(suggestedTrades[index]);
        setShowResults(false);
        setValidTrade(true);
        setInvalidTrade(false);
    }

    const searchTrades = (e: React.ChangeEvent<HTMLInputElement>) => {
        let searchTerm = e.target.value;
        setValidTrade(false);
        setSelectedTrade(searchTerm);
        setSelectedTradeObject(null);

        if (searchTerm !== "") {
            document.getElementById('search-results')?.scroll({ top: 0, behavior: 'smooth' });
            setShowResults(true);
            setExactTrades(trades.filter(x => x.description.toLowerCase().includes(searchTerm.toLowerCase())));
            setSuggestedTrades(trades.filter(x => x.keywords.toLowerCase().includes(searchTerm.toLowerCase())));
        } else {
            setShowResults(false);
            setExactTrades([]);
            setSuggestedTrades([]);
        }
    }

    const updateStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedStatus(e.target.value);
        setInvalidStatus(e.target.value === "");
    }

    const navigateToYourBusiness = () => {
        if ((validTrade || IsWebReference("PO")) && selectedStatus !== "") {

        let storedQuestions = JSON.parse(localStorage.getItem('questions') || "");

        let tradeQuestionID = 0;
        let statusQuestionID = 0;
        const assumptions: string[] = [];
        storedQuestions.map((question: any) => {
            if (selectedTrade !== "") {
                if (question.questionSetQuestion.text === "What is your main trade?" && selectedTradeObject.keywords !== "customadded") {
                    let selectedTradeAnswer = question.answerList.find((x: { text: string; }) => x.text.toLocaleLowerCase() === selectedTradeObject.description.toLocaleLowerCase()).value;
                    question.answer = selectedTradeAnswer;
                    tradeQuestionID = question.questionSetQuestion.questionID;
                }

                if (question.questionSetQuestion.text === "What is your main trade?" && selectedTradeObject.keywords === "customadded") {
                    question.answer = '';
                }
            }

            if (question.questionSetQuestion.text === "What is your Company Status?") {
                let statusText = "";
                if (selectedStatus === "limited") {
                    statusText = "Limited";
                }

                if (selectedStatus === "partner") {
                    statusText = "Partnership";
                }

                if (selectedStatus === "trader") {
                    statusText = "Individual Trading As";
                }

                let selectedStatusAnswer = question.answerList.filter((x: { text: string; }) => x.text.toLocaleLowerCase() === statusText.toLocaleLowerCase())[0].value;
                question.answer = selectedStatusAnswer;
                statusQuestionID = question.questionSetQuestion.questionID;
            }

            if (question.sectionName.toLowerCase().includes("assumptions") && question.questionSetQuestion.enabled === true) {
                assumptions.push(question.questionSetQuestion.text);
            }
            return question;
        });

            if (selectedTradeObject !== "") {
                // enable questions based on trade selected
                if (selectedTradeObject.keywords !== "customadded" && !IsWebReference("PO")) {
                    storedQuestions = enableQuestionsInSet(storedQuestions, tradeQuestionID);
                }
            } else {
                localStorage.removeItem("trade");
            }
        
        // enable questions based on company status selected
        storedQuestions = enableQuestionsInSet(storedQuestions, statusQuestionID);
            localStorage.setItem('questions', JSON.stringify(storedQuestions));
            if (selectedTradeObject !== "") {
                localStorage.setItem('trade', JSON.stringify(selectedTradeObject));
            }
            localStorage.setItem('status', selectedStatus);

            navigate("/YourBusiness");
        } else {
            setInvalidTrade(!validTrade);
            setInvalidStatus(selectedStatus === "");
        }
    }

    return (
        <div className="trade-status-form-wrapper">
            <h1>About You</h1>
            {!IsWebReference("PO") && 
                <>
                <label>Trade</label>
                <div className="search-container">
                    <div className="search-inner">
                        <input
                            type="text"
                            value={selectedTrade}
                            id={"valen_trade"}
                            onChange={(e) => searchTrades(e)}
                            placeholder="Enter your trade here"
                            className={tradeClassNames}
                        />
                    </div>
                    {showResults &&
                        <div className="dropdown" id="search-results">
                            {exactTrades.length > 0 &&
                                <div className="dropdown-row title">Exact Matches</div>}
                            {exactTrades.map((trade, index) => (
                                <div className="dropdown-row" key={"exact_" + index} onClick={() => selectExactTrade(index)}>{trade.description}</div>
                            ))}
                            {suggestedTrades.length > 0 &&
                                <div className="dropdown-row title">Suggestions</div>}
                            {suggestedTrades.map((trade, index) => (
                                <div className="dropdown-row" key={"suggested_" + index} onClick={() => selectSuggestedTrade(index)}>{trade.description}</div>
                            ))}
                        </div>
                    }
                </div>
                </>
            }
            <label>Company Status</label>
            <select value={selectedStatus}
                onChange={(e) => updateStatus(e)}
                className={statusClassNames}>
                <option>
                </option>
                <option value="limited">
                    Limited Company
                </option>
                <option value="partner">
                    Partnership
                </option>
                <option value="trader">
                    Sole Trader
                </option>
            </select>

            <button onClick={() => navigateToYourBusiness()} className="btn primary">Next: Your Business</button>
        </div>
    );
};

